import styled from 'styled-components';
import colors from '../../../lib/Colors';
import fonts from '../../../lib/Fonts';

const StyledLabel = styled.span`
    color: ${({error}) => error ? colors.red : colors.mediumGray} !important;
    position: absolute;
    font-size: 0.625em;
    left: 6px;
    top: 1px;
`;

const StyledSubmitButtonWrapper = styled.div`
  margin-top: 11px;
  width: 100%;
`;

const FormHeader = styled.h2`
  font-size: 1.75em;
  color: ${colors.almostBlack};
  font-family: ${fonts.family.workSans};
  margin: 0;
  font-weight: 300;
`;

const CreateRetailerFormMessage = styled.p`
  margin: 1em 0 1em 0;
  font-size: 14px;
  color: ${colors.colorDefaultheaderText};
  font-family: ${fonts.family.workSans};
`;

const GoogleAutofillWrapper = styled.div`
  margin: 15px 0 15px 0;
  font-family: ${fonts.family.workSans};
`;

const RadioContainer = styled.div`
 margin: 0 0 30px 0;
`;

const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  margin: 15px 0 0 0;
`;
const WaitLabel = styled.div`
  font-weight: 600;
`;

const WaitMessage = styled.div`
  margin-top: 5px;
`;

export {
  StyledLabel,
  FormHeader,
  CreateRetailerFormMessage,
  GoogleAutofillWrapper,
  MessageContainer,
  WaitLabel,
  WaitMessage,
  RadioContainer,
  StyledSubmitButtonWrapper
};
